export enum EntityTypes {
  Billing = 'billing',
  MLMBilling = 'mlm-billing',
}
